import { connect } from 'react-redux';
import {
  getActivities,
  markActivitiesAsRead,
} from '../actions/activity';
import { Activity } from '../presentation/Activity';

const mapStateToProps = state => ({
  activity: state.activity,
});

const mapDispatchToProps = dispatch => ({
  getActivities: () => dispatch(getActivities()),
  markActivitiesAsRead: () => dispatch(markActivitiesAsRead()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activity);



// WEBPACK FOOTER //
// ./scripts/containers/ActivityContainer.jsx